(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const orderedSelectors = [
    '.product-information--block-flash-message-1',
    '.product-information--block-ideal-scale, .product-information--block-ideal_scale',
    '.product-information--block-highlight-features-mobile-placement',
    '.product-information--under-gallery-block-collapsible-tab, .product-information--under-gallery-block-collapsible_tab, .product-information--under-gallery-block-type-collapsible-tab',
    '.product-information--under-gallery-block-specifications-tab, .product-information--under-gallery-block-specifications_tab, .product-information--under-gallery-block-type-specifications-tab',
    '.product-information--block-flash-message-2',
    '.product-information--block-complementary',
    '.product-information--block-side-panel, .product-information--block-side_panel'
  ];
  const allSelectors = [
    '.product-information--block-buy-buttons, .product-information--block-buy_buttons',
    ...orderedSelectors
  ].join(',');
  const productStates = new WeakMap();

  function getUniqueElements(root, selectors) {
    return selectors.flatMap((selector) => Array.from(root.querySelectorAll(selector)))
      .filter((element, index, elements) => elements.indexOf(element) === index);
  }

  function getState(product) {
    if (!productStates.has(product)) {
      const originalPositions = getUniqueElements(product, [allSelectors]).map((element) => ({
        element,
        parent: element.parentNode,
        nextSibling: element.nextSibling
      }));

      productStates.set(product, {
        originalPositions,
        isReordered: false
      });
    }

    return productStates.get(product);
  }

  function restoreProduct(product) {
    const state = productStates.get(product);
    if (!state || !state.isReordered) return;

    state.originalPositions.slice().reverse().forEach(({ element, parent, nextSibling }) => {
      if (!parent || !element) return;

      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(element, nextSibling);
      } else {
        parent.appendChild(element);
      }
    });

    state.isReordered = false;
  }

  function reorderProduct(product) {
    const state = getState(product);
    const formBlock = product.querySelector('.product-information--block-buy-buttons, .product-information--block-buy_buttons');
    if (!formBlock) return;

    let anchor = formBlock;
    getUniqueElements(product, orderedSelectors).forEach((element) => {
      anchor.after(element);
      anchor = element;
    });

    state.isReordered = true;
  }

  function updateProductOrder() {
    document.querySelectorAll('.thb-product-detail').forEach((product) => {
      if (mobileQuery.matches) {
        reorderProduct(product);
      } else {
        restoreProduct(product);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductOrder);
  } else {
    updateProductOrder();
  }

  mobileQuery.addEventListener('change', updateProductOrder);
  document.addEventListener('shopify:section:load', updateProductOrder);
})();
